export default  {"src":"/_next/static/image/public/assets/nevo-boi/addCarBoi.d4db9bf4f36293d6f594231d28750c05.svg","height":127,"width":127};